import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { Link } from 'react-router-dom';

// import './loans.css';


const NamesInGrid = ( { row, contacts } ) => {
    const [ show, setShow ] = useState( false );
    const [ hasMultiple, setHasMultiple ] = useState( false );
    const [ pri, setPri ] = useState( {} );

    const handleOnMouseEnter = () => {
        setShow( true );
    }
    const handleOnMouseLeave = () => {
        setShow( false );
    }

    const ref = useRef();

    const popup = (
        <Popover id="popover-basic" className='tf-multi-lead-badge-container' onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <Popover.Header as="h3">Leads</Popover.Header>
            <Popover.Body>
                { 
                    row.relationships.map( ( r, idx ) => {
                        return (
                            <Row key={`${r.cid}-${idx}`} className='text-start py-1' style={ { fontSize: '12px' } }>
                                <Col className='ps-0'><Link to={`/contact/${r.cid}`}>{contacts[r.cid].name}</Link></Col>
                            </Row>
                        )
                    } ) 
                }
            </Popover.Body>
        </Popover>
    );

    useEffect( () => {
        if ( row && row.relationships && row.relationships.length ) {
            row.relationships.sort( ( a, b ) => {
                const ad = new Date( a.createdDate );
                const bd = new Date( b.createdDate );
                return ad.getTime() - bd.getTime();
            } );
            const lor = row.relationships[0];
            const c = contacts[lor.cid];
            setPri( { 
                cid: c.cid, 
                name: c.name
            } );
            setHasMultiple( row.relationships.length > 1 );
        }
    }, [ row, contacts ] );

    return (
        <Container>
            <Row className='p-0'>
                <Col xs='auto' className='p-0 pe-2'><Link to={`/contact/${pri.cid}`}>{pri.name}</Link></Col>
                {
                    hasMultiple ? (
                        <OverlayTrigger placement="right" overlay={popup} show={show} container={document.body}>
                            <Col xs='auto' className='tf-multi-lead-badge ps-1 pe-1 align-items-center' ref={ref} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>{`+${row.relationships.length - 1}`}</Col>
                        </OverlayTrigger>
                    ) : (
                        null
                    )
                }
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    contacts: state.contacts.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.loans.loadActives
} );
  
export default connect( mapProps, mapDispatch )( NamesInGrid );